var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1179 18.3335C14.7852 18.3335 18.5688 14.5499 18.5688 9.88257C18.5688 5.21525 14.7852 1.43164 10.1179 1.43164C5.4506 1.43164 1.66699 5.21525 1.66699 9.88257C1.66699 14.5499 5.4506 18.3335 10.1179 18.3335ZM13.7338 7.35235C14.0338 7.05224 14.0338 6.56589 13.7338 6.26578C13.4338 5.96577 12.9473 5.96577 12.6473 6.26578L10.1175 8.79557L7.58764 6.26578C7.28763 5.96577 6.80118 5.96577 6.50117 6.26578C6.20111 6.56589 6.20111 7.05224 6.50117 7.35235L9.03095 9.88213L6.50117 12.4119C6.20111 12.712 6.20111 13.1984 6.50117 13.4985C6.80118 13.7985 7.28763 13.7985 7.58764 13.4985L10.1175 10.9687L12.6473 13.4985C12.9473 13.7985 13.4338 13.7985 13.7338 13.4985C14.0338 13.1984 14.0338 12.712 13.7338 12.4119L11.204 9.88213L13.7338 7.35235Z",
    fill: "#7F869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectNone);
export default __webpack_public_path__ + "static/media/selectNone.0f9df3224fc6882f5d17e0102325d2cd.svg";
export { ForwardRef as ReactComponent };